import { useState } from 'react';

/**
 * <HubTabs> — ひとつの仕事をひとつの画面に。
 *
 * シンプルメニュー（設定 → モジュール設定・既定 ON）で、今まで別々のメニューに
 * なっていた同じ仕事（設備・貸出・フロアマップ・部品表）を 1 枚にまとめる。
 * タブは「見られる人に見える分だけ」。1 つしか無いときはタブ自体を出さない
 * （シンプルメニューを OFF にしたときは、従来どおり 1 画面に見える）。
 */
export const HubTabs = ({ tabs = [], initial = null, testid = 'hub' }) => {
  const visible = tabs.filter((t) => t && t.visible !== false);
  const [key, setKey] = useState(() => {
    const want = visible.find((t) => t.key === initial);
    return (want || visible[0] || {}).key;
  });
  if (visible.length === 0) return null;
  if (visible.length === 1) return <div data-testid={`${testid}-single`}>{visible[0].node}</div>;
  const active = visible.find((t) => t.key === key) || visible[0];
  return (
    <div className="space-y-4" data-testid={testid}>
      <div className="flex flex-wrap items-center gap-1.5 border-b border-zinc-200 pb-2"
        role="tablist" data-testid={`${testid}-tablist`}>
        {visible.map((t) => (
          <button key={t.key} type="button" role="tab" aria-selected={t.key === active.key}
            onClick={() => setKey(t.key)}
            data-testid={`${testid}-tab-${t.key}`}
            className={`rounded-full px-3.5 py-1.5 text-[13px] font-semibold transition-colors ${
              t.key === active.key
                ? 'bg-teal-700 text-white'
                : 'text-zinc-600 hover:bg-zinc-100'}`}>
            {t.label}
          </button>
        ))}
      </div>
      <div data-testid={`${testid}-panel-${active.key}`}>{active.node}</div>
    </div>
  );
};

export default HubTabs;
